module.exports = __webpack_public_path__ + "img/google.ab08286c.svg";